module.exports = {"name":"nodeTreeLinks","source":"nodeTree","transform":[{"type":"treelinks","key":{"expr":"datum.path + ':' + datum.level"}},{"type":"linkpath","orient":"horizontal","shape":"diagonal"}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/data/tree/links.json
// module id = 1sgT
// module chunks = 0